import React from 'react';
import { apiContext } from '../../../Api';
import useAuth from '../../main/Auth/useAuth';
import scopusLogo from "../../../assets/img/scopus.png";
import thomsonLogo from "../../../assets/img/thomsonReuters.png";
import googleLogo from "../../../assets/img/googleScholar.png";
import sintaLogo from "../../../assets/img/garuda.png";



export default function Biodata({ user }) {
    const { axios } = React.useContext(apiContext);
    const { profile: refreshProfile } = useAuth();

    const [showEditModal, setShowEditModal] = React.useState(false);
    const [alias, setAlias] = React.useState("");
    const [fokus, setFokus] = React.useState("");
    const [about, setAbout] = React.useState("");
    const [scopus, setScopus] = React.useState("");
    const [thomson, setThomson] = React.useState("");
    const [google, setGoogle] = React.useState("");
    const [sinta, setSinta] = React.useState("");
    const [aliasError, setAliasError] = React.useState("");
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        if (user) {
            setAlias(user.alias || "");
        }
        if (user?.profile) {
            setFokus(user.profile.fokus || "");
            setAbout(user.profile.about || "");
            setScopus(user.profile.scopus || "");
            setThomson(user.profile.thomson || "");
            setGoogle(user.profile.google || "");
            setSinta(user.profile.sinta || "");
            setAlias(user.alias || "");
        }
    }, [user]);

    const handleEditProfile = async (e) => {
        e.preventDefault();
        setAliasError("");
        setLoading(true);
        const data = {
            alias: alias,
            fokus: fokus,
            about: about,
            scopus: scopus,
            thomson: thomson,
            google: google,
            sinta: sinta,
        }

        try {
            await axios.post('/profile-post', data);
            setShowEditModal(false);
            refreshProfile();
        } catch (err) {
            if (err.response?.status === 422 && err.response?.data?.errors?.alias) {
                setAliasError(err.response.data.errors.alias[0]);
            } else {
                console.error(err);
            }
        } finally {
            setLoading(false);
        }
    };
    const profile = user?.profile;

    return (
        <>
            <section className="rounded-lg border border-slate-200 bg-white p-5 shadow-soft lg:col-span-3">
                <div className="flex items-center justify-between">
                    <h2 className="font-display text-2xl font-extrabold text-brand-navy">Tentang Saya</h2>
                    <button
                        onClick={() => setShowEditModal(true)}
                        className="inline-flex items-center gap-2 rounded-lg bg-brand-navy px-4 py-2 text-sm font-extrabold text-white transition hover:bg-slate-800"
                    >
                        Edit Profile
                    </button>
                </div>
                <div className="my-4 h-px bg-slate-200" />

                {user.profile ? (
                    <p className="text-base leading-8 text-slate-600">
                        {user.profile.about || 'Tentang belum tersedia.'}
                    </p>
                ) : (
                    <p className="text-base leading-8 text-slate-500">Biodata belum tersedia.</p>
                )}

                <h3 className="mt-6 text-base font-extrabold text-brand-navy">Riwayat pendidikan</h3>
                <div className="mt-5 relative">
                    {/* Garis vertikal timeline */}
                    <div className="absolute left-[55px] top-2 bottom-2 w-px bg-slate-200"></div>

                    <div className="flex flex-col space-y-6">
                        {
                            user.pendidikan.map((item, index) => {
                                return (
                                    <div key={index} className="relative z-10 flex items-start gap-4">
                                        <div className="w-[42px] shrink-0 text-right font-extrabold text-brand-blue pt-1">
                                            {item.tahun_lulus}
                                        </div>

                                        <div className="shrink-0 pt-[6px]">
                                            <div className="h-4 w-4 rounded-full border-[4px] border-brand-navy bg-white ring-[3px] ring-white"></div>
                                        </div>

                                        <div className="flex-1 pb-2">
                                            <h4 className="text-xl font-extrabold text-brand-navy leading-none">{item.nama_jenjang}</h4>
                                            <p className="mt-2 text-slate-500">{item.nama_perguruan_tinggi}</p>
                                            <div className="mt-3">
                                                <span className="inline-block rounded-md border border-brand-blue/30 bg-brand-soft px-3 py-1 text-sm font-semibold text-brand-blue">
                                                    {item.program_studi}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

                <h3 className="mt-10 text-lg font-extrabold text-brand-navy">Fokus Riset Penelitian</h3>
                <p className="mt-3 text-base leading-8 text-slate-600">{profile?.fokus || '-'}</p>

                <div className="mt-10">
                    <h3 className="text-lg font-extrabold text-brand-navy">ID Publikasi Terindeks</h3>
                    <div className="mt-4 flex flex-wrap gap-4">
                        {profile?.sinta ? (
                            <a href={`https://sinta.kemdiktisaintek.go.id/authors/profile/${profile.sinta}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-5 py-3 transition hover:-translate-y-1 hover:border-brand-blue hover:shadow-md">
                                <img src={sintaLogo} alt="Sinta" className="h-7 w-auto object-contain drop-shadow-sm" />
                                <div>
                                    <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">SINTA ID</span>
                                    <span className="block font-extrabold text-brand-navy">{profile.sinta}</span>
                                    {profile?.sinta_overall !== null && profile?.sinta_overall !== undefined && (
                                        <span className="block text-[10px] font-bold text-brand-gold mt-0.5">
                                            Score Overall: {profile.sinta_overall}
                                        </span>
                                    )}
                                </div>
                            </a>
                        ) : null}

                        {profile?.scopus ? (
                            <a href={`https://www.scopus.com/authid/detail.uri?authorId=${profile.scopus}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-5 py-3 transition hover:-translate-y-1 hover:border-brand-blue hover:shadow-md">
                                <img src={scopusLogo} alt="Scopus" className="h-7 w-auto object-contain drop-shadow-sm" />
                                <div>
                                    <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">Scopus ID</span>
                                    <span className="block font-extrabold text-brand-navy">{profile.scopus}</span>
                                </div>
                            </a>
                        ) : null}

                        {profile?.google ? (
                            <a href={`https://scholar.google.com/citations?user=${profile.google}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-5 py-3 transition hover:-translate-y-1 hover:border-brand-blue hover:shadow-md">
                                <img src={googleLogo} alt="Google Scholar" className="h-7 w-auto object-contain drop-shadow-sm" />
                                <div>
                                    <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">Scholar ID</span>
                                    <span className="block max-w-[120px] truncate font-extrabold text-brand-navy">{profile.google}</span>
                                </div>
                            </a>
                        ) : null}

                        {profile?.thomson ? (
                            <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-5 py-3">
                                <img src={thomsonLogo} alt="Thomson/WoS" className="h-7 w-auto object-contain drop-shadow-sm" />
                                <div>
                                    <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">WoS ID</span>
                                    <span className="block max-w-[120px] truncate font-extrabold text-brand-navy">{profile.thomson}</span>
                                </div>
                            </div>
                        ) : null}

                        {!profile?.sinta && !profile?.scopus && !profile?.google && !profile?.thomson && (
                            <p className="text-sm italic text-slate-400">Data ID publikasi belum ditambahkan.</p>
                        )}
                    </div>
                </div>
            </section>
            <aside className="rounded-2xl border border-slate-200 bg-white shadow-soft overflow-hidden">
                <div className="h-24 bg-brand-navy/5 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px]"></div>

                <div className="px-6 pb-6 text-center">
                    <div className="-mt-12 mb-4 flex justify-center">
                        {user.profile?.foto ? (
                            <img src={user.profile.foto} alt={user?.name || 'Foto profil'} className="aspect-square w-28 rounded-full border-4 border-white object-cover shadow-md" />
                        ) : (
                            <div className="flex aspect-square w-28 items-center justify-center rounded-full border-4 border-white bg-slate-100 text-4xl font-extrabold text-slate-400 shadow-md">
                                {(user?.name || '?').charAt(0).toUpperCase()}
                            </div>
                        )}
                    </div>

                    <h2 className="text-xl font-extrabold text-brand-navy">{user?.name}</h2>
                    <span className="mt-1 inline-block rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500">
                        NIP. {user?.username}
                    </span>

                    {user?.alias && (
                        <div className="mt-4 flex justify-center">
                            <a href={`https://fsd.unsam.ac.id/${user.alias}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-lg border border-brand-gold/30 bg-brand-gold/10 px-4 py-2 text-xs font-bold text-yellow-700 hover:bg-brand-gold/20 transition hover:shadow-sm">
                                <i className="fas fa-external-link-alt"></i>
                                fsd.unsam.ac.id/{user.alias}
                            </a>
                        </div>
                    )}

                    <div className="mt-6 flex flex-col gap-3 rounded-xl bg-slate-50 p-4 text-left border border-slate-100">
                        <div>
                            <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">Program Studi</span>
                            <span className="mt-0.5 block font-semibold text-brand-navy">{profile?.prodi?.nama || '-'}</span>
                        </div>
                        <div className="h-px w-full bg-slate-200"></div>
                        <div>
                            <span className="block text-xs font-bold uppercase tracking-wider text-slate-400">Fakultas</span>
                            <span className="mt-0.5 block font-semibold text-brand-navy">{profile?.fakultas?.nama || '-'}</span>
                        </div>
                    </div>
                </div>
            </aside>

            {showEditModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden bg-slate-900/50 p-4">
                    <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
                        <h3 className="text-xl font-bold text-brand-navy">Edit Profile</h3>
                        <form onSubmit={handleEditProfile} className="mt-4 flex flex-col gap-4">
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Alias URL Profile (FSD)</label>
                                <input
                                    type="text"
                                    value={alias}
                                    onChange={(e) => {
                                        setAlias(e.target.value);
                                        setAliasError("");
                                    }}
                                    className={`mt-1 block w-full rounded-md border ${aliasError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-slate-300 focus:border-brand-green focus:ring-brand-green'} p-2 shadow-sm focus:outline-none focus:ring-1`}
                                    placeholder="Contoh: namasaya"
                                />
                                {aliasError ? (
                                    <span className="text-xs text-red-500 mt-1 block">{aliasError}</span>
                                ) : (
                                    <span className="text-xs text-slate-400 mt-1 block">Akan menjadi: https://fsd.unsam.ac.id/<b>{alias || 'alias'}</b></span>
                                )}
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Fokus Riset</label>
                                <input
                                    type="text"
                                    value={fokus}
                                    onChange={(e) => setFokus(e.target.value)}
                                    className="mt-1 block w-full rounded-md border border-slate-300 p-2 shadow-sm focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green"
                                    placeholder="Contoh: AI, Web Development"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700">Tentang (About)</label>
                                <textarea
                                    value={about}
                                    onChange={(e) => setAbout(e.target.value)}
                                    rows="3"
                                    className="mt-1 block w-full rounded-md border border-slate-300 p-2 shadow-sm focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green"
                                />
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-slate-700">SINTA ID</label>
                                    <input
                                        type="number"
                                        value={sinta}
                                        onChange={(e) => setSinta(e.target.value)}
                                        className="mt-1 block w-full rounded-md border border-slate-300 p-2 shadow-sm focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700">Scopus ID</label>
                                    <input
                                        type="number"
                                        value={scopus}
                                        onChange={(e) => setScopus(e.target.value)}
                                        className="mt-1 block w-full rounded-md border border-slate-300 p-2 shadow-sm focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700">Google Scholar ID</label>
                                    <input
                                        type="text"
                                        value={google}
                                        onChange={(e) => setGoogle(e.target.value)}
                                        className="mt-1 block w-full rounded-md border border-slate-300 p-2 shadow-sm focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-slate-700">Thomson/WoS ID</label>
                                    <input
                                        type="text"
                                        value={thomson}
                                        onChange={(e) => setThomson(e.target.value)}
                                        className="mt-1 block w-full rounded-md border border-slate-300 p-2 shadow-sm focus:border-brand-green focus:outline-none focus:ring-1 focus:ring-brand-green"
                                    />
                                </div>
                            </div>

                            <div className="mt-4 flex justify-end gap-3">
                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={() => setShowEditModal(false)}
                                    className="rounded-lg px-4 py-2 text-sm font-bold text-slate-600 transition hover:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Batal
                                </button>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="rounded-lg bg-brand-green px-4 py-2 text-sm font-bold text-white transition hover:bg-emerald-600 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2 min-w-[90px]"
                                >
                                    {loading ? (
                                        <>
                                            <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Menyimpan...
                                        </>
                                    ) : (
                                        "Simpan"
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
